module.exports = __webpack_public_path__ + "img/back-white.c5ee2508.svg";